import { ENDPOINT } from '../globals/endpoint';
import { apiHelper } from '../helpers/api-helper';

interface VcardResponse {
  status: string;
  cardNumber: string;
  cardUserFirstName: string;
  cardUserLastName: string;
  cvv: string;
  expirationDate: string;
  provider: string;
  product: string;
  updateDeliveryDateUrl: string;
  updateOrderIdUrl: string;
  billingAddress: VCardBillingAddress;
}

interface VCardBillingAddress {
  line1: string;
  line2: string;
  city: string;
  state: string;
  zip: string;
}

export const checkout = async (): Promise<VcardResponse> => {
  const url = ENDPOINT.Checkout;

  const response = await apiHelper(url, {
    method: 'POST',
  });

  const res = await response.json();

  return response.ok ? res : void 0;
};
